import { BidAnalysisDetailsDependencies } from '@/features/bid-analysis/bid-analysis-details-dependencies';

const BidAnalysisLayout = () => {
  return <BidAnalysisDetailsDependencies/>;
};

export default BidAnalysisLayout;
